import * as styles from "./styles.css";
import { navigateTo } from "../../../utils/common";
import { PlaceholderImage } from "../../atoms/placeholder-image";
import { AppBar } from "../../molecules/app-bar";
import { Typography, Tags, HeaderVariants } from "../../atoms/typography";
import { SonicImageDplus } from "../../atoms/sonic-image";
import { Link } from "../../atoms/link";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Icon, Icons } from "../../../components/atoms/icon";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
const CampaignLandingPage = ({ campaignLandingBannerM, }) => {
    const campaignLandingPage = M.fromMaybe(campaignLandingBannerM, {});
    const description = M.fromMaybe(campaignLandingPage.descriptionM, "");
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.goBack, onClick: () => navigateTo(config.standardPageRouteFragments.home) },
            React.createElement(Icon, { type: Icons.LeftArrow, className: styles.backArrow, color: "white" })),
        React.createElement("div", { className: styles.appBar },
            React.createElement(AppBar, { title: campaignLandingPage.name, container: styles.appBarContainer })),
        React.createElement(Link, { href: campaignLandingPage.route },
            React.createElement("div", { className: styles.mobileBannerWrapper },
                React.createElement("div", { className: styles.placeholderstyleM },
                    React.createElement(PlaceholderImage, null)),
                React.createElement(SonicImageDplus, { src: campaignLandingPage.image.src, quality: 75, className: styles.bannerImage, width: 600 }))),
        React.createElement("div", { className: styles.descriptionWrapperM },
            React.createElement("div", { className: styles.titleDescContainer },
                React.createElement(Typography, { classNameM: M.of(styles.campaignTitle), variant: HeaderVariants.headingOne, tag: Tags.span },
                    React.createElement(React.Fragment, null, description)))),
        React.createElement("div", { className: styles.bannerWrapper },
            React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.maincontainer },
                    React.createElement(Link, { href: campaignLandingPage.route },
                        React.createElement("div", { className: styles.thumnailWrapper },
                            React.createElement("div", { className: styles.placeholderstyle },
                                React.createElement(PlaceholderImage, null)),
                            React.createElement("div", { className: styles.heroImageContainer },
                                React.createElement(SonicImageDplus, { src: campaignLandingPage.image.src, quality: 75, className: styles.bannerImage, width: 600 }),
                                React.createElement("div", { className: styles.hoverlay },
                                    React.createElement("div", { className: styles.detailContainer },
                                        React.createElement("div", { className: styles.titleDescContainer },
                                            React.createElement(Typography, { classNameM: M.of(styles.campaignTitle), variant: HeaderVariants.headingOne, tag: Tags.span },
                                                React.createElement(React.Fragment, null, description)))))))))))));
};
export default CampaignLandingPage;

